module.exports = __webpack_public_path__ + "img/Produtos03.fw.4b6a07de.png";